import React, { useMemo } from "react";
import EndingShipped from "./sub-components/EndingShipped";
import ShippedToday from "../../utilites/ShippedToday";
import { Card, Col, Container, Row } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";
import { AverageValuesSkeleton } from "../screening/sub-components/skeleton";

const Shipped = React.memo(({ allShippingList, isShippingLoading }) => {
  const totalCount = allShippingList?.totalCount ?? 0;
  const totalFreightCount = allShippingList?.totalFreightCount ?? 0;
  const totalGroundCount = allShippingList?.totalGroundCount ?? 0;
  const dailyAverage = allShippingList?.dailyAverage ?? 0;
  const totalYesterdayCount = allShippingList?.totalYesterdayCount ?? 0;
  const weeklyAverage = allShippingList?.weeklyAverage ?? 0;
  const monthlyAverage = allShippingList?.monthlyAverage ?? 0;

  const chartOptions = useMemo(() => ({
    chart: { type: "donut", foreColor: "#ffffff", height: 412 },
    legend: { show: false },
    dataLabels: { enabled: false },
    tooltip: { enabled: false },
    fill: { colors: ["#e8eb34", "#ff5156"] },
    states: {
      hover: { filter: { type: "lighten", value: 0.5 } },
      active: { filter: { type: "none", value: 0 } },
    },
    stroke: { width: 0 },
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: "60%",
          labels: {
            show: true,
            name: { show: false },
            total: {
              show: true,
              showAlways: true,
              formatter: (w) => {
                const totals = w.globals.seriesTotals;
                return totals.reduce((sum, val) => sum + val, 0);
              },
            },
          },
        },
      },
    },
  }), []);

  return (
      <div>
        <p className="secondHeader">Shipped</p>
        {isShippingLoading ? (
            <AverageValuesSkeleton />
        ) : (
            <>
              <EndingShipped
                  title="Shipped"
                  totalFreightCount={totalFreightCount}
                  totalGroundCount={totalGroundCount}
                  orderCount={totalCount}
              />

              <Card className="endingStyle">
                <Container>
                  <Row>
                    <Col style={{ paddingTop: "48px" }}>
                      <p style={{ textAlign: "center", fontSize: 14 }}>High Score</p>
                      <p className="green" style={{ fontSize: "22px" }}>
                        N/A
                      </p>
                    </Col>

                    <Col style={{ paddingTop: "0px" }}>
                      <p style={{ textAlign: "center", fontSize: 14 }}>Shipped Today</p>
                      <ReactApexChart
                          options={chartOptions}
                          series={[totalCount]}
                          type="donut"
                          height={150}
                          width={150}
                      />
                    </Col>

                    <Col style={{ paddingTop: "48px" }}>
                      <p style={{ textAlign: "center", fontSize: 14 }}>Daily Average</p>
                      <p className="green" style={{ fontSize: "22px" }}>
                        {dailyAverage}
                      </p>
                    </Col>
                  </Row>
                </Container>
              </Card>

              <ShippedToday
                  title="Shipped"
                  value={{
                    today: totalCount,
                    yesterday: totalYesterdayCount,
                    ground: totalGroundCount,
                    freight: totalFreightCount,
                  }}
              />

              <Card className="endingStyle">
                <Container>
                  <Row>
                    <Col style={{ paddingTop: "38px", textAlign: "center" }}>
                      <p style={{ fontSize: 14 }}>
                        Daily Average
                        <br />
                        <span style={{ color: "#588b4c", fontSize: 18 }}>
                      {dailyAverage} Orders
                    </span>
                      </p>
                      <p style={{ fontSize: 14 }}>
                        Weekly Average
                        <br />
                        <span style={{ color: "#588b4c", fontSize: 18 }}>
                      {weeklyAverage} Orders
                    </span>
                      </p>
                      <p style={{ fontSize: 14 }}>
                        Monthly Average
                        <br />
                        <span style={{ color: "#588b4c", fontSize: 18 }}>
                      {monthlyAverage} Orders
                    </span>
                      </p>
                    </Col>
                  </Row>
                </Container>
              </Card>
            </>
        )}
      </div>
  );
});

export default Shipped;
